<dx-popup
    #logReturnedMail
    width="50%"
    height="50%"
    minWidth="35%"
    minHeight="50%"
    [title]="pageTitle"
    [showTitle]="true"
    [resizeEnabled]="true"
    [(visible)]="visible"
    (onShown)="onShown($event)"
    (onHidden)="onHidden($event)"
>
    <div *dxTemplate="let item of 'content'" class="log-returned-mail-content">
        <dx-box *ngIf="!!editorResult" width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <dx-box width="100%" height="100%" [direction]="isSmallScreen ? 'col' : 'row'">
                    <dxi-item [ratio]="1">
                        <dx-form
                            width="100%"
                            height="100%"
                            labelLocation="top"
                            [readOnly]="true"
                            [colCount]="1"
                            [formData]="editorResult"
                        >
                            <dxi-item itemType="group" caption="Selected Owner" [colCount]="1">
                                <dxi-item dataField="customerId">
                                    <dxo-label text="Account Number"></dxo-label>
                                </dxi-item>
                                <dxi-item dataField="community">
                                    <dxo-label text="Community"></dxo-label>
                                </dxi-item>
                                <dxi-item dataField="owner">
                                    <dxo-label text="Owner"></dxo-label>
                                </dxi-item>
                                <dxi-item dataField="mailingAddress1">
                                    <dxo-label text="Mailing Address 1"></dxo-label>
                                </dxi-item>
                                <dxi-item dataField="mailingAddress2">
                                    <dxo-label text="Mailing Address 2"></dxo-label>
                                </dxi-item>
                            </dxi-item>
                        </dx-form>
                    </dxi-item>
                    <dxi-item [ratio]="isSmallScreen ? 1 : 2">
                        <dx-box width="100%" height="100%" direction="col" class="log-returned-mail-editor">
                            <dxi-item baseSize="auto">
                                <dx-form
                                    #editorForm
                                    width="100%"
                                    height="100%"
                                    labelLocation="top"
                                    validationGroup="editorFormGroup"
                                    [colCount]="1"
                                    [formData]="editorParams"
                                >
                                    <dxi-item itemType="group" caption="Log Returned Mail" [colCount]="2">
                                        <dxi-item dataField="mailReceivedOn" editorType="dxDateBox" [isRequired]="true">
                                            <dxo-label text="Date Received"></dxo-label>
                                        </dxi-item>
                                        <dxi-item
                                            dataField="returnedReasonCode"
                                            editorType="dxSelectBox"
                                            [editorOptions]="{
                                                dataSource: editorResult.returnedReasons,
                                                displayExpr: 'displayText',
                                                valueExpr: 'key'
                                            }"
                                            [isRequired]="true"
                                        >
                                            <dxo-label text="Returned Reason"></dxo-label>
                                        </dxi-item>
                                        <dxi-item
                                            dataField="mailClassCode"
                                            editorType="dxSelectBox"
                                            [editorOptions]="{
                                                dataSource: editorResult.mailClass,
                                                displayExpr: 'displayText',
                                                valueExpr: 'key'
                                            }"
                                            [isRequired]="true"
                                        >
                                            <dxo-label text="Mail Class"></dxo-label>
                                        </dxi-item>
                                        <dxi-item
                                            dataField="mailTypeCode"
                                            editorType="dxSelectBox"
                                            [editorOptions]="{
                                                dataSource: editorResult.mailType,
                                                displayExpr: 'displayText',
                                                valueExpr: 'key'
                                            }"
                                            [isRequired]="true"
                                        >
                                            <dxo-label text="Mail Type"></dxo-label>
                                        </dxi-item>
                                        <dxi-item
                                            dataField="addressMatches"
                                            editorType="dxSelectBox"
                                            [editorOptions]="{
                                                dataSource: editorResult.addressMatchesActions,
                                                displayExpr: 'displayText',
                                                valueExpr: 'key',
                                                onSelectionChanged: onAddressMatchesChange
                                            }"
                                            [isRequired]="true"
                                        >
                                            <dxo-label text="Does Address Match?"></dxo-label>
                                        </dxi-item>
                                        <dxi-item
                                            dataField="updateMailingAddress"
                                            editorType="dxSwitch"
                                            [editorOptions]="{
                                                width: '80px',
                                                elementAttr: { class: 'update-address-switch' },
                                                switchedOnText: 'Yes',
                                                switchedOffText: 'No',
                                                disabled: !editorParams.addressMatches
                                            }"
                                        >
                                            <dxo-label text="Update Mailing Address"></dxo-label>
                                        </dxi-item>
                                    </dxi-item>
                                </dx-form>
                            </dxi-item>
                            <dxi-item baseSize="auto">
                                <dx-form
                                    #addressForm
                                    width="100%"
                                    height="100%"
                                    labelLocation="left"
                                    validationGroup="editorFormGroup"
                                    [readOnly]="!editorParams.updateMailingAddress"
                                    [colCount]="1"
                                    [formData]="mailingAddress"
                                >
                                    <dxi-item itemType="group" caption="Mailing Address">
                                        <dxi-item
                                            dataField="address01"
                                            [isRequired]="editorParams.updateMailingAddress"
                                        >
                                            <dxo-label text="Address Line 1"></dxo-label>
                                        </dxi-item>
                                        <dxi-item dataField="address02">
                                            <dxo-label text="Address Line 2"></dxo-label>
                                        </dxi-item>
                                        <dxi-item dataField="city" [isRequired]="editorParams.updateMailingAddress">
                                            <dxo-label text="City / State"></dxo-label>
                                            <div *dxTemplate class="city-state-fields">
                                                <dx-text-box
                                                    [(value)]="mailingAddress.city"
                                                    [readOnly]="!editorParams.updateMailingAddress"
                                                ></dx-text-box>
                                                <div class="cc-spacer"></div>
                                                <dx-select-box
                                                    displayExpr="state"
                                                    valueExpr="code"
                                                    placeholder="Select State"
                                                    [searchEnabled]="true"
                                                    [dataSource]="states"
                                                    [(value)]="mailingAddress.state"
                                                    [readOnly]="!editorParams.updateMailingAddress"
                                                ></dx-select-box>
                                            </div>
                                        </dxi-item>
                                        <dxi-item
                                            dataField="countryCode"
                                            [isRequired]="editorParams.updateMailingAddress"
                                        >
                                            <dxo-label text="Zip / Country"></dxo-label>
                                            <div *dxTemplate class="zip-country-fields">
                                                <dx-text-box
                                                    [(value)]="mailingAddress.postalCode"
                                                    [readOnly]="!editorParams.updateMailingAddress"
                                                ></dx-text-box>
                                                <div class="cc-spacer"></div>
                                                <dx-select-box
                                                    displayExpr="country"
                                                    valueExpr="code"
                                                    placeholder="Select Country"
                                                    [searchEnabled]="true"
                                                    [dataSource]="countries"
                                                    [(value)]="mailingAddress.countryCode"
                                                    [readOnly]="!editorParams.updateMailingAddress"
                                                ></dx-select-box>
                                            </div>
                                        </dxi-item>
                                    </dxi-item>
                                </dx-form>
                            </dxi-item>
                        </dx-box>
                    </dxi-item>
                </dx-box>
            </dxi-item>
            <dxi-item baseSize="auto">
                <dx-toolbar width="100%">
                    <dxi-item location="before">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Cancel"
                                hint="Cancel"
                                [icon]="iconCancel"
                                (onClick)="onCancelClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-button
                                type="success"
                                text="Save"
                                hint="Save"
                                validationGroup="editorFormGroup"
                                [icon]="iconSace"
                                [useSubmitBehavior]="true"
                                (onClick)="onSaveClick($event)"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-toolbar>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel
    [position]="{ of: '#logReturnedMail' }"
    *ngIf="loadingVisible"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
